import { MiniKit, VerificationLevel } from "@worldcoin/minikit-js";
// import { IDKitWidget, useIDKit } from '@worldcoin/idkit'
import { Fragment, useCallback, useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux'
import { handleMinikitUser, setUserData } from '../../../main/slices/userSlice';
import { setBankData } from '../../../main/slices/bankSlice';

import { Text } from "../FormControls/Text";
import { Box } from "../FormControls/Box";
import { Button } from "../FormControls/Button";
import { Stack } from "../FormControls/Stack";
import { AccountBalance, ArrowForward } from "@mui/icons-material";
import { LoadingIcon } from '../FormControls/LoadingIcon';

//const user = useSelector(({ user }) => user);

const verifyPayload = {
  action: 'verify_user',
  signal: "", //'1234567891', //---> Valor unico; si queremos validar que solo una vez realice este paso;
  verification_level: VerificationLevel.Device, // Orb | Device
};

export default function MiniKitProvider(){
  const [cookies, setCookies] = useCookies();
  // const { open, setOpen } = useIDKit();
  useEffect(() => {
    setCookies("closeSesion", false);
    if (process.env.REACT_APP_DEBUG) console.log("Debug activo");
    MiniKit.install();
    // setOpen(true);
  }, []);

  const dispatch = useDispatch();
  const [handleVerifyResponse, setHandleVerifyResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleVerify = useCallback(async () => {
    if(!MiniKit.isInstalled()||loading){ 
      console.warn("MiniKit no está instalado o no se detectó el entorno correcto");
      return null; 
    }
    
    const { finalPayload } = await MiniKit.commandsAsync.verify(verifyPayload);
    if (finalPayload.status === "error" || !finalPayload.nullifier_hash){
      setHandleVerifyResponse(finalPayload);
      return finalPayload;
    }
    let toSend = {
      payload: finalPayload,
      action: verifyPayload.action,
      userId: finalPayload.nullifier_hash,
      
    }

    setLoading(true);
    const verifyResponse = await verifyEndpoint(toSend);

    setHandleVerifyResponse(verifyResponse);
    setLoading(false);
    return verifyResponse;
  }, []);

  const verifyEndpoint = async (args) => await dispatch(handleMinikitUser(args)).unwrap()
    .then(({ response }) => {
      console.log("actualizar usuario")
      if(response?.user){
        console.log("response actualizar")
        dispatch(setUserData(response.user));
        dispatch(setBankData(response.user));
      }
      return response;
  })
  .catch((e) =>{ console.log(e); return e; });

  return (
    <Fragment>
      <div style={{ padding: "0 1.5rem" }}>
        <div style={{ marginBottom: "15rem" }}></div>
        <Stack flex={{ flexDirection: "column" }}>
          <Text classes={["title", "center"]}>
            {" "}
            ¡Cobra tus productos con Worldcoins!{" "}
          </Text>
        </Stack>

        <Stack flex={{ flexDirection: "column" }}>
          {/* CALL TO ACTION */}
          <div style={{ marginBottom: "10rem" }}></div>
          <Stack flex={{ flexDirection: "row", alignItems: "center" }}>
            <Button key={"login"} classes={["btnFullwidth", "alignBtnContent", (loading ? "" : "cobrarBtn")]} onClick={handleVerify}>
              {!loading ? <>Iniciar<ArrowForward fontSize='small' sx={{ marginLeft: '0.5em' }} /></> :<><LoadingIcon></LoadingIcon></>}
            </Button>
          </Stack>
        </Stack>
      </div>
    </Fragment>
  );
  {/*}
  <IDKitWidget app_id={process.env.REACT_APP_APP_ID} action="login" signal="123456789" onSuccess={handleVerify} verification_level="device">
    {({ open }) => <button onClick={open}>Verify with World ID</button>}
  </IDKitWidget>
  {*/}
}
